function makeStars(el, count) {
    const container = document.getElementById(el);
    if (!container) return;
    for (let i = 0; i < count; i++) {
      const s = document.createElement("span");
      s.className = "star";
      s.textContent = "★";
      s.style.top = Math.random() * 100 + "%";
      s.style.left = Math.random() * 100 + "%";
      s.style.fontSize = (Math.random() * 10 + 6) + "px";
      s.style.opacity = Math.random() * 0.6 + 0.2;
      container.appendChild(s);
    }
  }
  makeStars("heroStars", 40);
  makeStars("valuesStars", 50);
  makeStars("footerStars", 30);
  function makeSmallStars(el, count) {
    const container = document.getElementById(el);
    if (!container) return;
    for (let i = 0; i < count; i++) {
      const s = document.createElement("i");
      s.textContent = "★";
      s.style.top = Math.random() * 100 + "%";
      s.style.left = Math.random() * 100 + "%";
      s.style.fontSize = (Math.random() * 8 + 5) + "px";
      s.style.opacity = Math.random() * 0.7 + 0.3;
      container.appendChild(s);
    }
  }
  makeSmallStars("pStars1", 20);
  makeSmallStars("pStars2", 20);

  document.querySelectorAll('.stella-collection-template .product-image-stars[id]').forEach(function (el) {
    if (el.getAttribute('data-stella-stars-init')) return;
    el.setAttribute('data-stella-stars-init', '1');
    makeSmallStars(el.id, 14);
  });

  // Smooth scroll for nav anchor links
  document.querySelectorAll('.nav a[href^="#"], .nav-dropdown-menu a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (document.activeElement) document.activeElement.blur();
      }
    });
  });

  // Click-to-flip bag on product card
  document.querySelectorAll('.product-image-flip').forEach(function(flip) {
    flip.addEventListener('click', function(e) {
      e.stopPropagation();
      flip.classList.toggle('flipped');
    });
  });

function swapImg(targetId, src, thumbEl) {
    var img = document.getElementById(targetId);
    if (img) img.src = src;
    if (thumbEl) {
      var parent = thumbEl.parentElement;
      if (parent) {
        parent.querySelectorAll('.product-thumb').forEach(function(t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
      }
      thumbEl.classList.add('active');
      thumbEl.setAttribute('aria-selected', 'true');
    }
  }

function stellaFormatMoney(cents) {
  cents = parseInt(cents, 10);
  if (isNaN(cents)) return '';
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.stellaMoneyFormat) {
    return Shopify.formatMoney(cents, window.stellaMoneyFormat);
  }
  var major = (cents / 100).toFixed(2);
  if (window.stellaMoneyFormat && window.stellaMoneyFormat.indexOf('amount') !== -1) {
    return window.stellaMoneyFormat.replace(/\{\{\s*amount\s*\}\}/, major).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }
  return '$' + major;
}

function stellaReadQtyRulesFromBox(box) {
  if (!box) return { min: 1, inc: 1, max: 99 };
  var min = parseInt(box.getAttribute('data-qty-min'), 10);
  if (isNaN(min) || min < 1) min = 1;
  var inc = parseInt(box.getAttribute('data-qty-inc'), 10);
  if (isNaN(inc) || inc < 1) inc = 1;
  var maxAttr = box.getAttribute('data-qty-max');
  var max = maxAttr != null && maxAttr !== '' ? parseInt(maxAttr, 10) : 99;
  if (isNaN(max)) max = 99;
  if (max < min) max = min;
  return { min: min, inc: inc, max: max };
}

function stellaNearestValidQty(raw, min, max, inc) {
  var q = parseInt(raw, 10);
  if (isNaN(q)) q = min;
  q = Math.max(min, Math.min(max, q));
  if (inc <= 1) return q;
  var k = Math.round((q - min) / inc);
  q = min + k * inc;
  if (q > max) {
    k = Math.floor((max - min) / inc);
    q = min + k * inc;
  }
  if (q < min) q = min;
  return q;
}

function stellaApplyVariantQtyRules(opt, box) {
  if (!opt || !box) return;
  ['data-qty-min', 'data-qty-inc', 'data-qty-max'].forEach(function (attr) {
    var val = opt.getAttribute(attr);
    if (val != null && val !== '') box.setAttribute(attr, val);
  });
}

function stellaNormalizeQtyForBox(box) {
  if (!box) return;
  var rules = stellaReadQtyRulesFromBox(box);
  var form = box.querySelector('form.stella-product-form');
  var inp = form ? form.querySelector('input[name="quantity"]') : null;
  if (!inp) return;
  inp.setAttribute('min', String(rules.min));
  inp.setAttribute('step', String(rules.inc));
  inp.setAttribute('max', String(rules.max));
  var q = stellaNearestValidQty(inp.value, rules.min, rules.max, rules.inc);
  inp.value = String(q);
}

function stellaNormalizeQtyInForm(form) {
  if (!form) return;
  var box = form.closest('.product-info');
  stellaNormalizeQtyForBox(box);
}

function stellaClearAddToCartError(form) {
  if (!form) return;
  var row = form.querySelector('.stella-add-to-cart-error');
  if (row) row.remove();
}

function stellaShowAddToCartError(form, message) {
  if (!form) return;
  stellaClearAddToCartError(form);
  var el = document.createElement('p');
  el.className = 'stella-add-to-cart-error';
  el.setAttribute('role', 'alert');
  el.textContent = message || 'Could not add to cart';
  var btn = form.querySelector('.btn-add-cart');
  if (btn && btn.parentNode) btn.parentNode.insertBefore(el, btn);
  else form.appendChild(el);
}

function stellaSyncBuyBoxTotals(box) {
  if (!box) return;
  var unit = parseInt(box.getAttribute('data-stella-unit-price-cents'), 10);
  if (isNaN(unit)) return;
  var form = box.querySelector('form.stella-product-form');
  var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
  var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
  if (isNaN(qty) || qty < 1) qty = 1;
  var line = unit * qty;
  var m = stellaFormatMoney(line);
  box.querySelectorAll('.stella-purchase-price').forEach(function (n) {
    n.textContent = m;
  });
}

function updateQty(delta, productIdx) {
  var input = document.getElementById('qty' + productIdx);
  if (!input) return;
  var step = parseInt(input.getAttribute('step'), 10) || 1;
  var min = parseInt(input.getAttribute('min'), 10);
  if (isNaN(min)) min = 1;
  var maxAttr = input.getAttribute('max');
  var max = maxAttr != null && maxAttr !== '' ? parseInt(maxAttr, 10) : 99;
  if (isNaN(max)) max = 99;
  var v = parseInt(input.value, 10);
  if (isNaN(v)) v = min;
  v = v + delta;
  v = Math.max(min, Math.min(max, v));
  if (step > 1) {
    v = min + Math.round((v - min) / step) * step;
    if (v > max) v = max;
    if (v < min) v = min;
  }
  input.value = String(v);
  var box = input.closest('.product-info');
  stellaSyncBuyBoxTotals(box);
}
window.updateQty = updateQty;

function stellaApiUrl(path) {
  var p = String(path || '').replace(/^\//, '');
  var root = '';
  if (typeof window.stellaRootUrl === 'string') root = window.stellaRootUrl;
  if (!root && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    root = window.Shopify.routes.root;
  }
  if (!root || root === '/') return '/' + p;
  return root.replace(/\/+$/, '') + '/' + p;
}

function stellaUpdateNavCartBadge(cart) {
  if (!cart || typeof cart.item_count !== 'number') return;
  var el = document.querySelector('[data-stella-cart-count]');
  if (el) {
    el.textContent = String(cart.item_count);
    el.setAttribute('data-count', String(cart.item_count));
    el.style.display = cart.item_count > 0 ? '' : 'none';
  }
  var totalEl = document.querySelector('[data-stella-header-cart-total]');
  if (totalEl) {
    if (cart.item_count > 0 && typeof cart.total_price === 'number') {
      totalEl.textContent = stellaFormatMoney(cart.total_price);
      totalEl.style.display = '';
    } else {
      totalEl.textContent = '';
      totalEl.style.display = 'none';
    }
  }
}

function stellaFetchCartJson() {
  return fetch(stellaApiUrl('cart.js'), {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
    cache: 'no-store'
  }).then(function (r) {
    return r.json();
  });
}

var stellaCartUiRequestGen = 0;

/** Fetch latest cart and apply header + buy boxes. Ignores stale responses if a newer refresh started. */
function stellaRefreshCartUiFromServer(buyBoxMode) {
  buyBoxMode = buyBoxMode || 'live';
  var gen = ++stellaCartUiRequestGen;
  return stellaFetchCartJson()
    .then(function (cart) {
      if (gen !== stellaCartUiRequestGen) return null;
      stellaApplyCartStateToUi(cart, buyBoxMode);
      return cart;
    })
    .catch(function () {
      return null;
    });
}

function stellaGetVariantIdFromBuyBoxForm(form) {
  if (!form) return '';
  var sel = form.querySelector('select[name="id"]');
  if (sel) return String(sel.value || '').trim();
  var hid = form.querySelector('input[name="id"]');
  if (hid) return String(hid.value || '').trim();
  return '';
}

function stellaSumCartQtyForVariant(cart, variantId) {
  if (!cart || !cart.items || !variantId) return 0;
  var want = String(variantId);
  var sum = 0;
  cart.items.forEach(function (item) {
    if (String(item.variant_id) === want) sum += item.quantity || 0;
  });
  return sum;
}

/** mode 'page-load': only set qty from cart when that variant is in cart. mode 'live': also reset qty to variant min when that variant is not in the cart (recommended after real cart data). */
function stellaSyncBuyBoxFromCart(box, cart, mode) {
  if (!box || !cart) return;
  var form = box.querySelector('form.stella-product-form');
  if (!form) return;
  var vid = stellaGetVariantIdFromBuyBoxForm(form);
  if (!vid) return;
  var inp = form.querySelector('input[name="quantity"]');
  if (!inp) return;
  var inCart = stellaSumCartQtyForVariant(cart, vid);
  var rules = stellaReadQtyRulesFromBox(box);
  if (inCart > 0) {
    inp.value = String(inCart);
  } else if (mode === 'live') {
    inp.value = String(rules.min);
  }
  stellaNormalizeQtyForBox(box);
  stellaSyncBuyBoxTotals(box);
}

function stellaSyncAllBuyBoxesFromCart(cart, mode) {
  document.querySelectorAll('.product-info[data-stella-unit-price-cents]').forEach(function (box) {
    stellaSyncBuyBoxFromCart(box, cart, mode);
  });
}

function stellaApplyCartStateToUi(cart, buyBoxMode) {
  if (!cart) return;
  stellaUpdateNavCartBadge(cart);
  stellaSyncAllBuyBoxesFromCart(cart, buyBoxMode || 'live');
}

function stellaBuildCartUpdatesPayload(form) {
  var updates = {};
  if (!form) return updates;
  form.querySelectorAll('.stella-cart-qty-input[data-stella-line-key]').forEach(function (inp) {
    var key = inp.getAttribute('data-stella-line-key');
    if (!key) return;
    var q = parseInt(inp.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    updates[key] = q;
  });
  return updates;
}

function stellaClearCartUpdateError(form) {
  var n = form && form.querySelector('.stella-cart-update-error');
  if (n) n.remove();
}

function stellaShowCartUpdateError(form, message) {
  if (!form) return;
  stellaClearCartUpdateError(form);
  var el = document.createElement('p');
  el.className = 'stella-cart-update-error';
  el.setAttribute('role', 'alert');
  el.textContent = message || 'Could not update cart';
  var wrap = form.querySelector('.stella-cart-table-wrap');
  if (wrap && wrap.parentNode) wrap.parentNode.insertBefore(el, wrap);
  else form.insertBefore(el, form.firstChild);
}

function stellaLineCentsFromCartItem(item) {
  if (!item) return 0;
  if (typeof item.final_line_price === 'number') return item.final_line_price;
  if (typeof item.line_price === 'number') return item.line_price;
  return 0;
}

function stellaApplyCartPageFromCartJson(form, cart) {
  if (!form || !cart) return;
  var subEl = form.querySelector('[data-stella-cart-page-total]');
  if (subEl && typeof cart.total_price === 'number') {
    subEl.textContent = stellaFormatMoney(cart.total_price);
  }
  var tbody = form.querySelector('tbody');
  if (!tbody) return;
  if (cart.item_count === 0) {
    window.location.reload();
    return;
  }
  var map = {};
  (cart.items || []).forEach(function (item) {
    map[item.key] = item;
  });
  tbody.querySelectorAll('tr[data-stella-line-key]').forEach(function (tr) {
    var key = tr.getAttribute('data-stella-line-key');
    var item = map[key];
    if (!item) {
      tr.remove();
      return;
    }
    var qtyInp = tr.querySelector('.stella-cart-qty-input');
    if (qtyInp) qtyInp.value = String(item.quantity);
    var lineTd = tr.querySelector('[data-stella-line-total]');
    if (lineTd) lineTd.textContent = stellaFormatMoney(stellaLineCentsFromCartItem(item));
  });
}

function stellaPostCartUpdateFromForm(form) {
  var updates = stellaBuildCartUpdatesPayload(form);
  if (Object.keys(updates).length === 0) {
    return Promise.resolve(null);
  }
  stellaClearCartUpdateError(form);
  var updateBtn = form.querySelector('button[name="update"]');
  if (updateBtn) updateBtn.disabled = true;
  return fetch(stellaApiUrl('cart/update.js'), {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ updates: updates })
  })
    .then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        try {
          data = text ? JSON.parse(text) : null;
        } catch (parseErr) {
          data = null;
        }
        return { ok: res.ok, status: res.status, data: data, text: text };
      });
    })
    .then(function (out) {
      if (!out.ok) {
        if (out.status === 422) {
          console.warn('[Stella] cart/update.js 422', out.data || out.text);
        }
        var msg =
          (out.data && (out.data.description || out.data.message)) ||
          (out.data &&
            out.data.errors &&
            (typeof out.data.errors === 'string' ? out.data.errors : JSON.stringify(out.data.errors))) ||
          (out.text && out.text.slice(0, 240)) ||
          'Could not update cart';
        throw new Error(msg);
      }
      return out.data;
    })
    .then(function (cart) {
      stellaApplyCartPageFromCartJson(form, cart);
      try {
        document.dispatchEvent(new CustomEvent('stella:cart:updated', { detail: { cart: cart } }));
      } catch (x) {}
      return cart;
    })
    .catch(function (err) {
      console.warn('[Stella] cart/update.js failed', err);
      stellaShowCartUpdateError(form, err.message || 'Could not update cart');
    })
    .finally(function () {
      if (updateBtn) updateBtn.disabled = false;
    });
}

var stellaCartQtyDebounceTimer;

function stellaInitCartPageAjax() {
  var form = document.querySelector('form.stella-cart-form');
  if (!form) return;
  form.addEventListener('change', function (e) {
    if (!e.target.classList.contains('stella-cart-qty-input')) return;
    clearTimeout(stellaCartQtyDebounceTimer);
    stellaPostCartUpdateFromForm(form).catch(function () {});
  });
  form.addEventListener('input', function (e) {
    if (!e.target.classList.contains('stella-cart-qty-input')) return;
    clearTimeout(stellaCartQtyDebounceTimer);
    stellaCartQtyDebounceTimer = setTimeout(function () {
      stellaPostCartUpdateFromForm(form).catch(function () {});
    }, 480);
  });
}

function stellaSyncNavCartFromServer() {
  return stellaRefreshCartUiFromServer('live');
}

function toggleMobileNav(btn) {
    var nav = btn.closest('.nav');
    if (!nav) return;
    var isOpen = nav.classList.toggle('menu-open');
    btn.classList.toggle('open', isOpen);
    document.body.classList.toggle('menu-is-open', isOpen);
  }
  // Close mobile menu when any nav link is tapped
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.nav a');
    if (link && link.getAttribute('href')) {
      var nav = document.querySelector('.nav.menu-open');
      if (nav) {
        nav.classList.remove('menu-open');
        var burger = nav.querySelector('.mobile-burger.open');
        if (burger) burger.classList.remove('open');
        document.body.classList.remove('menu-is-open');
      }
    }
  });

// Zoom / lightbox functionality

  function openZoom(src) {
    var overlay = document.getElementById('zoomOverlay');
    var img = document.getElementById('zoomImg');
    if (!overlay || !img) return;
    img.src = src;
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeZoom(e) {
    if (e && e.target && e.target.tagName === 'IMG' && e.target.id === 'zoomImg') return;
    var overlay = document.getElementById('zoomOverlay');
    if (!overlay) return;
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeZoom();
  });
  
  // Wire up every product-main-image as a click-to-zoom trigger
  document.querySelectorAll('.product-main-image').forEach(function(container) {
    container.addEventListener('click', function() {
      // Find the currently visible image inside this container
      var visibleImg = container.querySelector('img:not([style*="display:none"]):not([style*="display: none"])');
      if (!visibleImg) {
        // For 4-pack with the stack, pick the topmost visible
        var imgs = container.querySelectorAll('img');
        for (var i = 0; i < imgs.length; i++) {
          if (imgs[i].offsetWidth > 0) { visibleImg = imgs[i]; break; }
        }
      }
      if (visibleImg && visibleImg.src) {
        openZoom(visibleImg.src);
      }
    });
  });
  
  // 4-pack bundle: swap between stack-of-4 display and back-of-bag image (mainImg2 or same gallery on PDP)
  function swap4Pack(which, thumbEl) {
    var mainImg = document.getElementById('mainImg2');
    if (!mainImg && thumbEl) {
      var gal = thumbEl.closest('.product-gallery');
      if (gal) mainImg = gal.querySelector('img[data-front]');
    }
    if (!mainImg) return;
    mainImg.src = (which === 'front') ? mainImg.getAttribute('data-front') : mainImg.getAttribute('data-back');
    if (thumbEl) {
      var parent = thumbEl.parentElement;
      if (parent) {
        parent.querySelectorAll('.product-thumb').forEach(function(t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
      }
      thumbEl.classList.add('active');
      thumbEl.setAttribute('aria-selected', 'true');
    }
  }
window.swap4Pack = swap4Pack;

// Measure nav-left when menu opens so nav-right stacks cleanly below it
  (function() {
    function updateMenuLayout() {
      var nav = document.querySelector('.nav.menu-open');
      if (!nav) return;
      var navLeft = nav.querySelector('.nav-left');
      if (!navLeft) return;
      // Height of nav-left content + its top offset (96px)
      var totalOffset = 96 + navLeft.offsetHeight;
      nav.style.setProperty('--nav-right-offset', totalOffset + 'px');
    }
    var observer = new MutationObserver(function() {
      requestAnimationFrame(updateMenuLayout);
    });
    var navEl = document.querySelector('.nav');
    if (navEl) {
      observer.observe(navEl, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', updateMenuLayout);
  })();
// PDP / product gallery thumbs (delegated: theme editor blocks + scrollable tab strip)
document.body.addEventListener('click', function(e) {
  var el = e.target.closest('.product-thumbs .product-thumb[data-src]');
  if (!el) return;
  var src = el.getAttribute('data-src');
  var tid = el.getAttribute('data-swap-target') || 'mainImg1';
  if (src) swapImg(tid, src, el);
});
document.body.addEventListener('keydown', function(e) {
  var el = e.target.closest('.product-thumbs .product-thumb[data-src]');
  if (!el) return;
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    el.click();
  }
});

document.addEventListener('stella:cart:updated', function (e) {
  try {
    var cart = e.detail && e.detail.cart;
    if (cart) stellaApplyCartStateToUi(cart, 'live');
  } catch (err) {}
});

document.querySelectorAll('.stella-variant-select').forEach(function(sel) {
  sel.addEventListener('change', function() {
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var cents = opt.getAttribute('data-price-cents');
    var box = sel.closest('.product-info');
    if (box) {
      stellaApplyVariantQtyRules(opt, box);
      if (cents != null) box.setAttribute('data-stella-unit-price-cents', cents);
      stellaRefreshCartUiFromServer('live').catch(function () {});
    }
    var imgId = sel.getAttribute('data-main-img');
    var src = opt.getAttribute('data-image');
    if (src && imgId) {
      var mi = document.getElementById(imgId);
      if (mi) mi.src = src;
    }
  });
});

document.body.addEventListener('input', function (e) {
  if (!e.target || e.target.name !== 'quantity') return;
  if (!e.target.closest('form.stella-product-form')) return;
  var box = e.target.closest('.product-info');
  stellaSyncBuyBoxTotals(box);
});

document.body.addEventListener('submit', async function (e) {

  var form = e.target;

  if (!form || form.nodeName !== 'FORM' || !form.classList.contains('stella-product-form')) return;

  e.preventDefault();

  const formData = new FormData(form);

  const variantId = formData.get('id');
  const quantity = parseInt(formData.get('quantity')) || 1;

  try {

    const cart = await fetch('/cart.js').then(r => r.json());

    const existing = cart.items.find(item => item.variant_id == variantId);

    if (existing) {

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: existing.key,
          quantity: quantity
        })
      });

    } else {

      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

    }

    window.location.href = '/cart';

  } catch(err) {

    console.log(err);

  }

});

function stellaInitBuyBoxLineTotals() {
  document.querySelectorAll('.product-info[data-stella-unit-price-cents]').forEach(function (box) {
    stellaNormalizeQtyForBox(box);
    stellaSyncBuyBoxTotals(box);
  });
}
var stellaVisibilityCartTimer;

function stellaInitCartLifecycleListeners() {
  if (window.stellaCartLifecycleListeners) return;
  window.stellaCartLifecycleListeners = true;
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) stellaRefreshCartUiFromServer('live').catch(function () {});
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    var ae = document.activeElement;
    if (
      ae &&
      ae.name === 'quantity' &&
      typeof ae.closest === 'function' &&
      ae.closest('form.stella-product-form')
    ) {
      return;
    }
    clearTimeout(stellaVisibilityCartTimer);
    stellaVisibilityCartTimer = setTimeout(function () {
      stellaRefreshCartUiFromServer('live').catch(function () {});
    }, 280);
  });
}

function stellaDomReadyInit() {
  stellaInitCartLifecycleListeners();
  stellaInitBuyBoxLineTotals();
  stellaInitCartPageAjax();
  stellaSyncNavCartFromServer();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', stellaDomReadyInit);
} else {
  stellaDomReadyInit();
}


function updateQty(change, suffix) {

  const input = document.getElementById('qty' + suffix);

  let value = parseInt(input.value) || 1;

  value += change;

  if (value < 1) value = 1;

  input.value = value;
}

